import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: "#08044c", // Dark Blue (AppBar)
    },
    secondary: {
      main: "#08044c", // Dark Blue (Buttons = AppBar)
      hover: "#0a0660", // Dark Blue hover
    },
    subtle: {
      main: "#e8e4e4", // Light Gray (Buttons)
      hover: "#d8d0d0", // Light Gray (Buttons)
    },
    error: {
      main: "#d32f2f", // Dark Red (Cancel/Delete Buttons)
    },
    background: {
      default: "#ffffff", // White (Background)
      secondary: "#f5f5f5", // Light Gray (Background)
    },
    text: {
      primary: "#131313", // Dark Gray or Black (Text)
    },
    icon: {
      primary: "#757575",
      secondary: "e8e4e4",
    },
  },
  typography: {
    fontSize: 14, // Base font size in pixels
    htmlFontSize: 18,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#fafafa",
          transition: "box-shadow 0.2s, border-color 0.2s",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d0d0d0",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#999",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#08044c",
            borderWidth: 2,
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(8, 4, 76, 0.08)",
            backgroundColor: "#fff",
          },
        },
        input: {
          padding: "14px 16px",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.92rem",
          "&.Mui-focused": {
            color: "#08044c",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "medium",
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          marginTop: 4,
        },
        option: {
          borderRadius: 6,
          margin: "2px 6px",
          "&:hover": {
            backgroundColor: "rgba(8, 4, 76, 0.06)",
          },
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#08044c", // Dark Blue (AppBar)
    },
    secondary: {
      main: "#08044c", // Dark Blue (Buttons = AppBar)
      hover: "#0a0660", // Dark Blue hover
    },
    error: {
      main: "#d32f2f", // Dark Red (Cancel/Delete Buttons)
    },
    background: {
      default: "#333333", // Dark Background
      secondary: "#515151", // Light Gray (Background)
    },
    text: {
      primary: "#ffffff", // White Text
    },
    icon: {
      primary: "#f0f0f0",
      secondary: "#606060",
    },
  },
  typography: {
    fontSize: 14, // Base font size in pixels
    htmlFontSize: 18,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#3a3a3a",
          transition: "box-shadow 0.2s, border-color 0.2s",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#555",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#888",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#90caf9",
            borderWidth: 2,
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(144, 202, 249, 0.15)",
            backgroundColor: "#444",
          },
        },
        input: {
          padding: "14px 16px",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.92rem",
          "&.Mui-focused": {
            color: "#90caf9",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "medium",
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          marginTop: 4,
        },
        option: {
          borderRadius: 6,
          margin: "2px 6px",
        },
      },
    },
  },
});
